import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Newspaper, TrendingUp, Star } from 'lucide-react';
import { clients } from '../lib/data';
import { Sparkline } from '../components/Sparkline';
const clientSentiment: Record<string, {
  positive: number;
  neutral: number;
  negative: number;
}> = {
  fii: {
    positive: 22,
    neutral: 18,
    negative: 7
  },
  acm: {
    positive: 58,
    neutral: 42,
    negative: 24
  },
  intrum: {
    positive: 9,
    neutral: 8,
    negative: 3
  },
  assoreti: {
    positive: 30,
    neutral: 25,
    negative: 8
  }
};
export function ClientSelection() {
  const navigate = useNavigate();
  return <div className="min-h-screen flex items-center justify-center p-4" style={{
    backgroundColor: '#1A1F2E'
  }} data-id="element-425">
      <div className="bg-card w-full max-w-2xl rounded-lg shadow-xl p-8 md:p-10" data-id="element-426">
        <div className="text-center mb-8" data-id="element-427">
          <div className="flex flex-col leading-tight justify-center items-center mb-4" data-id="element-428">
            <span className="font-logo text-[28px] tracking-wide" style={{
            color: '#0187c3'
          }} data-id="element-429">
              Esclapon
            </span>
            <span className="font-logo text-[28px] tracking-wide" style={{
            color: '#0187c3'
          }} data-id="element-430">
              & Co.
            </span>
          </div>
          <h1 className="text-2xl font-semibold tracking-tight" data-id="element-431">
            Seleziona un cliente
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-432">
          {clients.map(client => {
          const sentiment = clientSentiment[client.id] || {
            positive: 0,
            neutral: 0,
            negative: 0
          };
          const totalArticles = sentiment.positive + sentiment.neutral + sentiment.negative;
          return <button key={client.id} onClick={() => navigate('/home')} className="w-full flex flex-col p-5 rounded-xl border border-border hover:border-accent/50 hover:bg-accent/5 transition-all group text-left" data-id="element-433">
                {/* Logo + Name */}
                <div className="flex items-center gap-3 mb-4" data-id="element-434">
                  <div className="w-[80px] h-[28px] flex items-center justify-center bg-white rounded flex-shrink-0 px-1.5" data-id="element-435">
                    <img src={client.logo} alt={client.name} className="max-w-full max-h-full object-contain" data-id="element-436" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-437">
                    <div className="font-semibold text-base truncate group-hover:text-accent transition-colors" data-id="element-438">
                      {client.name}
                    </div>
                  </div>
                </div>

                {/* KPI Row */}
                <div className="flex items-center gap-4 text-sm" data-id="element-439">
                  <div className="flex items-center gap-1.5 text-muted-foreground" data-id="element-440">
                    <Newspaper className="h-3.5 w-3.5" data-id="element-441" />
                    <span style={{
                  fontVariantNumeric: 'tabular-nums'
                }} className="font-medium text-foreground" data-id="element-442">
                      {client.articlesThisMonth}
                    </span>
                    <span className="text-xs" data-id="element-443">art.</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-muted-foreground" data-id="element-444">
                    <Star className="h-3.5 w-3.5" data-id="element-445" />
                    <span style={{
                  fontVariantNumeric: 'tabular-nums'
                }} className="font-medium text-accent" data-id="element-446">
                      {client.overallScore.toFixed(1)}
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5 ml-auto" data-id="element-447">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#0187c3]" data-id="element-448" />
                    <span className="text-xs" style={{
                  fontVariantNumeric: 'tabular-nums'
                }} data-id="element-449">
                      {sentiment.positive}
                    </span>
                    <span className="w-1.5 h-1.5 rounded-full bg-[#64B5F6]" data-id="element-450" />
                    <span className="text-xs" style={{
                  fontVariantNumeric: 'tabular-nums'
                }} data-id="element-451">
                      {sentiment.neutral}
                    </span>
                    <span className="w-1.5 h-1.5 rounded-full bg-[#1A3A5C]" data-id="element-452" />
                    <span className="text-xs" style={{
                  fontVariantNumeric: 'tabular-nums'
                }} data-id="element-453">
                      {sentiment.negative}
                    </span>
                  </div>
                </div>

                {/* Sparkline */}
                <div className="mt-3 h-8 w-full opacity-60 group-hover:opacity-100 transition-opacity" data-id="element-454">
                  <Sparkline data={client.sparklineData} color="#0187c3" height={32} data-id="element-455" />
                </div>
              </button>;
        })}
        </div>
      </div>
    </div>;
}